export const ORDERABLE_ITEM_BY_ACCOUNT_ID = 'mac/FETCH_ORDERABLE_ITEM_BY_ACCOUNT_ID';
export const PRODUCT_PACKAGES_BY_KEYS = 'mac/FETCH_PRODUCT_PACKAGES_BY_KEYS';
export const EVALUATION_PRODUCTS = 'mac/FETCH_EVALUATION_PRODUCTS';
export const CURRENT_PRODUCT_PACKAGE = 'mac/FETCH_CURRENT_PRODUCT_PACKAGE';
export const BTF_PRODUCT_PACKAGE = 'mac/FETCH_BTF_PRODUCT_PACKAGE';
export const PRODUCT_PACKAGE = 'mac/FETCH_PRODUCT_PACKAGE';
export const PRODUCT_OFFERING_KEY_MAPPING = 'mac/FETCH_PRODUCT_OFFERING_KEY_MAPPING';
